import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import crashGame from 'games/CrashGame/slice-thunk/crashGame.slice'
import diceGame from 'games/DiceGame/slice-thunk/diceGame.slice'
import diceStrategy from 'games/DiceGame/slice-thunk//diceStrategy.slice'
import chat from './slices/chat.slice'

import loader from './slices/loader.slice'

const rootReducer = combineReducers({
  gameSetting,
  crashGame,
  diceGame,
  diceStrategy,
  auth: authSlice,
  loader,
  chat
})

export default rootReducer
